import React, { useState } from 'react';
import { Button, ModalProps } from 'antd';
import CommonModal from '../../../../components/Modals/CommonModal';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/app';
import { deleteWebhookData } from '../../../../store/WebHookSlice';

interface DeleteModalProps extends ModalProps {
	title?: string;
	close: any;
	open: boolean;
	deleteValues: any;
	name?: string | number;
	getList: any;
}

const DeleteWebhook: React.FC<DeleteModalProps> = ({ title, close, open, deleteValues, name, getList }) => {
	const dispatch: AppDispatch = useDispatch();
	const [saving, setSaving] = useState<boolean>(false);

	const deleteProduct = () => {
		setSaving(true);

		const payload = {
			id: deleteValues?._id,
		};

		dispatch(deleteWebhookData(payload))
			.then(() => {
				close();
				getList();
			})
			.catch(() => {
				close();
			})
			.finally(() => setSaving(false));
	};

	return deleteValues ? (
		<CommonModal
			className="deleteModal"
			title={`Delete ${name}: ${title}`}
			open={open ? true : false}
			onCancel={close}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="EditBtn"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					htmlType="button"
					type="primary"
					className="cancelBtn"
					loading={saving}
					onClick={deleteProduct}
				>
					Delete
				</Button>,
			]}
		>
			<div className="deleteNote">
				Are you sure want to delete
				<br />
				<strong>
					{name && <span>{name}:</span>} {title}
				</strong>
				?
			</div>
		</CommonModal>
	) : (
		<></>
	);
};
export default DeleteWebhook;
